import $ from 'jquery';

export default class initObserver {
  constructor() {
    const elem = document.querySelectorAll('.js-fv');
    const header = document.querySelector('#header');
    const fvOptions = {
      rootMargin: (header.clientHeight * -1) +'px 0px 0px 0px',
    };

    const observeUse = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelector('#header').classList.remove('inverse');
        } else {
          document.querySelector('#header').classList.add('inverse');
        }
      });
    };

    const fvObserver = new IntersectionObserver(observeUse, fvOptions);
    elem.forEach(iSObserver => {
      fvObserver.observe(iSObserver);
    });

    const reveal = document.querySelectorAll('.js-reveal');
    const options = {
      rootMargin: '0px 0px -10% 0px',
    };

    const setVisible = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    };

    const observer = new IntersectionObserver(setVisible, options);
    reveal.forEach(iSObserver => {
      observer.observe(iSObserver);
    });

    const fadein = document.querySelectorAll('.js-fadein');
    fadein.forEach(iSObserver => {
      observer.observe(iSObserver);
    });

  }
}

class watchScroll {
  constructor() {
    const header = document.querySelector('.l-header-career');

    if (!header) {
      return
    }

    let ticking = false;
    let scrollDiff = 0;

    document.addEventListener('scroll', (event) => {
      if (!ticking) {
        requestAnimationFrame(() => {
          ticking = false;

          // header スクロール方向に応じて出し分け
          if (window.scrollY > header.clientHeight) {
            if ((document.body.getBoundingClientRect()).top > scrollDiff) {
              header.classList.remove('is-hidden');
              header.classList.add('is-visible','is-fixed');
            } else {
              header.classList.remove('is-visible');
              header.classList.add('is-hidden','is-fixed');
            }
          } else {
            header.classList.remove('is-fixed','is-hidden');
          }

          scrollDiff = (document.body.getBoundingClientRect()).top;
        });
        ticking = true;
      }

    }, {passive: true});
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new initObserver();
  new watchScroll();
});
